import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { FRESH_ARTICLES_QUERY, FRESH_ARTICLES_WITH_CREATIVES_COUNT_QUERY } from './freshArticles.query';
import { getErrorsText, Severity, usePushNotifications } from 'services/NotificationService';
import { FreshArticlesQuery, FreshArticlesQueryVariables } from './__generated__/FreshArticlesQuery';
import {
  FreshArticlesWithCreativesCountQuery,
  FreshArticlesWithCreativesCountQueryVariables
} from './__generated__/FreshArticlesWithCreativesCountQuery';

export const useFreshArticlesQuery = () => {
  const notify = usePushNotifications();
  return useLazyQuery<FreshArticlesQuery, FreshArticlesQueryVariables>(FRESH_ARTICLES_QUERY, {
    client: kmsClient,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onError: (error) => notify({ title: 'Error', message: getErrorsText(error), severity: Severity.ERROR })
  });
};

export const useFreshArticlesWithCreativesCountQuery = () => {
  const notify = usePushNotifications();
  return useLazyQuery<FreshArticlesWithCreativesCountQuery, FreshArticlesWithCreativesCountQueryVariables>(
    FRESH_ARTICLES_WITH_CREATIVES_COUNT_QUERY,
    {
      client: kmsClient,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      onError: (error) => notify({ title: 'Error', message: getErrorsText(error), severity: Severity.ERROR })
    }
  );
};
